import { FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { AiTwotoneDelete } from 'react-icons/ai';
import { FaCircleCheck } from 'react-icons/fa6';
import { IoCloseCircle, IoPersonAdd } from 'react-icons/io5';
import PhoneInput from 'react-phone-input-2';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import styles from '../../../styles/modules/ChildProfile.module.css';
import { useDispatch } from 'react-redux';
import { EventAPI } from '../../../api/EventAPI';
import defaultProfileImg from '../../../assets/images/profile-picture.png';

const validationObj = Yup.object({
    name: Yup.string().required("Full name required"),
    email: Yup.string().email("Enter valid email").required("Email is required"),
    relation: Yup.string().required("Relation is required"),
    phone: Yup.string().max(100, "must not exceed 100 characters").required("Phone is required"),
})

const PlayerGuardian = ({ playerId, startLoading, finishLoading ,isAllow}) => {
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const [fieldErrors, setFieldErrors] = useState({});
    const [memberData, setMemberData] = useState({});
    const [isPhoneInputFocused, setIsPhoneInputFocused] = useState(false);
    const [isAdd, setIsAdd] = useState(false);
    const [guardians, setGuardians] = useState([]);
    const [isUpdate, setIsUpdate] = useState(false);
    const dispatch = useDispatch();

    const handleOnChange = (event) => {
        const { name, value } = event.target;
        setMemberData({ ...memberData, [name]: value });
        Object.keys(fieldErrors).length != 0 && setFieldErrors({});
    }

    const findAllGuardian = async () => {
        try {
            startLoading("loading1");
            const response = await EventAPI.getEventPlayerGuardians(playerId);
            //console.log(response);
            setGuardians(response.Data)

        } catch (error) {
            console.log(error);
        } finally {
            finishLoading("loading1");
        }
    };
    useEffect(() => {
        if (playerId) {
            findAllGuardian();
        }
        isUpdate && setIsUpdate(false);
    }, [isUpdate]);

    const handleRemoveFamilyMember = async (guardianId) => {
        try {
            startLoading("loading3")
            await EventAPI.putRemoveFamilyMemberFromPlayer({
                guardianId: guardianId,
                playerId: playerId,
                isChild: true
            })
            setIsUpdate(true);
        } catch (error) {
            console.log(error);
        } finally {
            finishLoading("loading3")
        }
    };

    const handleAddFamilyMemberToPlayer = async () => {
        try {
            startLoading("loading3")
            await validationObj.validate(memberData, { abortEarly: false });
            const name = memberData.name.split(" ");
            if (!name[1]) {
                setFieldErrors({ ...fieldErrors, name: 'Full name required' });
                return;
            }
            const reqObj = {
                firstName: name[0] ?? '',
                lastName: name[1] ?? '',
                email: memberData.email,
                mobile: "+" + memberData.phone,
                playerId: playerId,
                relationType: memberData.relation,
                isChild: true,
                clubId: selectedClub.clubId
            }


            await EventAPI.postAddFamilyMemberToPlayer(reqObj);
            setIsAdd(false);
            setIsUpdate(true);
            setMemberData({});
        } catch (error) {
            console.log(error);
            if (error.inner) {
                let obj = {};
                error.inner.forEach(err => {
                    obj[err.path] = err.message
                })
                setFieldErrors(obj)
            }
        } finally {
            finishLoading("loading3")
        }
    };


    return (
        <div className={styles['child_guardian_container']}>
           {isAllow &&
            <div className={styles['add_memeber_btn']}>
                <button onClick={() => setIsAdd(true)} typeof='buttom'> <IoPersonAdd className={styles['add_memeber_btn_icon']} />Add member</button>
            </div>}
            <table className={styles['child_guardian_table']}>
                <thead>
                    <tr>
                        <th align='left'></th>
                        <th align='left'>Name</th>
                        <th align='left'>Email</th>
                        <th align='left'>Phone</th>
                        <th align='left'>Status</th>
                        <th align='left'>Relation</th>
                        {isAllow && <th align='center'>Action</th>}
                    </tr>
                </thead>
                <tbody>
                    {guardians?.map((guardian) =>
                        <tr key={guardian.guardianId}>
                            <td className={styles['guardian_img']} align='center'><img src={guardian?.profileImage ? import.meta.env.VITE_APP_BASE_URL + '/user/user-profile-img/' + guardian?.profileImage : defaultProfileImg} alt="" /></td>
                            <td align='left'>{(guardian?.firstName ?? '') + " " + (guardian?.lastName ?? '')}</td>
                            <td align='left'>{guardian?.email}</td>
                            <td align='left'>{guardian?.mobile}</td>
                            {guardian?.status === 'ACTIVE' &&
                                <td align='left' className={styles['guardian_status']} >
                                    <span className={styles['guardian_status_active']}></span> Active
                                </td>}
                            {guardian?.status === 'PENDING' &&
                                <td align='left' className={styles['guardian_status']} >
                                    <span className={styles['guardian_status_pending']}></span> Pending
                                </td>}
                            <td align='left' style={{ textTransform: 'capitalize' }}>{guardian?.relationType}</td>
                            {isAllow && <td align='center'> <AiTwotoneDelete onClick={() => handleRemoveFamilyMember(guardian?.guardianId)} style={{ fontSize: '21px', cursor: 'pointer' }} /></td>}
                        </tr>)}
                    {isAdd &&
                        <tr>
                            <td colSpan={10}>
                                <form className='add_memeber_to_player_form'>
                                    <TextField
                                        fullWidth
                                        error={fieldErrors['name']}
                                        helperText={fieldErrors['name'] && fieldErrors['name']}
                                        name='name'
                                        className='add_memeber_to_player_form_input1'
                                        label="First Name Last Name"
                                        size='small'
                                        value={memberData?.name || ''}
                                        sx={{ background: 'white' }}
                                        onChange={handleOnChange}
                                    />
                                    <TextField
                                        fullWidth
                                        error={fieldErrors['email']}
                                        helperText={fieldErrors['email'] && fieldErrors['email']}
                                        name='email'
                                        className='add_memeber_to_player_form_input2'
                                        label="Email"
                                        value={memberData?.email || ''}
                                        onChange={handleOnChange}
                                        sx={{ background: 'white' }}
                                        size='small' />

                                    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                                        <PhoneInput
                                            country={'us'}
                                            containerStyle={isPhoneInputFocused ?
                                                fieldErrors['phone'] ?
                                                    {
                                                        color: '#d32f2f'
                                                    }
                                                    :
                                                    { color: 'var(--hoverColorBold)' }
                                                :
                                                fieldErrors['phone'] ?
                                                    {
                                                        color: '#d32f2f'
                                                    } : { color: 'black' }}
                                            inputStyle={isPhoneInputFocused ?
                                                fieldErrors['phone'] ?
                                                    {
                                                        border: '1px solid #d32f2f',
                                                        boxShadow: 'none',
                                                        width: '100%',
                                                        color: '#d32f2f',
                                                        borderRadius: '10px',
                                                        height: '20px'
                                                    } :
                                                    {
                                                        border: '2px solid var(--hoverColorBold)',
                                                        boxShadow: 'none',
                                                        transition: '.2s ease',
                                                        borderRadius: '10px',
                                                        width: '100%',
                                                        height: '20px'
                                                    } : fieldErrors['phone'] ?
                                                    {
                                                        border: '1px solid #d32f2f',
                                                        boxShadow: 'none',
                                                        width: '100%',
                                                        color: '#d32f2f',
                                                        borderRadius: '10px',
                                                        height: '20px'
                                                    } : { borderRadius: '10px', width: '100%', height: '20px' }}
                                            disableDropdown={true}
                                            value={memberData.phone || ''}
                                            onFocus={() => setIsPhoneInputFocused(true)}
                                            onBlur={() => setIsPhoneInputFocused(false)}
                                            onChange={(e) => handleOnChange({ target: { name: 'phone', value: e } })}
                                        />
                                        {fieldErrors['phone'] && <div style={{ fontSize: '12px', color: '#d32f2f', marginTop: '5px' }}>{fieldErrors['phone']}</div>}
                                    </div>
                                    <FormControl
                                        error={fieldErrors['relation']}
                                        sx={{ width: '60%', background: 'white' }}
                                        data-testid="game-dropdown"
                                        className='roster_add_family_member_relation_input'>
                                        <InputLabel sx={{
                                            top: '-8px', '&.Mui-focused': {
                                                top: '0px',
                                            },
                                            '&.MuiInputLabel-shrink': {
                                                top: '0px',
                                            },
                                            transition: 'top 0.2s ease'
                                        }} id="demo-simple-select-autowidth-label">Who Is This?</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            onChange={handleOnChange}
                                            value={memberData.relation || ''}
                                            fullWidth
                                            label="Who Is This?"
                                            name='relation'
                                            size='small'
                                        >
                                            <MenuItem value="father">Father</MenuItem>
                                            <MenuItem value="mother">Mother</MenuItem>
                                            <MenuItem value="grand_father">Grand Father</MenuItem>
                                            <MenuItem value="grand_mother">Grand Mother</MenuItem>
                                        </Select>
                                        {
                                            fieldErrors['relation'] &&
                                            <FormHelperText sx={{ color: 'red', m: 0 }}>
                                                {fieldErrors['relation']}
                                            </FormHelperText>
                                        }
                                    </FormControl>
                                    <div className="add_family_memeber_close_icon_container" >
                                        <FaCircleCheck onClick={handleAddFamilyMemberToPlayer} className='add_memeber_to_player_form_save_icon' />
                                        <IoCloseCircle className='add_memeber_to_player_form_close_icon' onClick={() => {
                                            setIsAdd(false);
                                            setMemberData({});
                                            Object.keys(fieldErrors).length != 0 && setFieldErrors({});
                                        }} />
                                    </div>
                                </form>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default PlayerGuardian